import { atom } from 'recoil';

const seasons = atom({
  key: 'seasons',
  default: [],
});
export default seasons;
